export const rem = (px, context = 16) => `${px / context}rem`;

export default rem;
